module.exports = __webpack_public_path__ + "media/images/CMTomar-8dad8ee4cb1704cb9181908067a6ffb2.png";